module.exports = "<svg width=\"50\" height=\"50\" viewBox=\"0 0 50 50\"><path d=\"M4.33 19.64l5.37 8.05 6.25-7.15\"/><path d=\"M9.71 27.69C8.36 16.81 16.68 8.38 26.06 8.03c9.37-.35 17.25 6.97 17.6 16.35.35 9.38-6.97 17.26-16.35 17.6\"/><path d=\"M26.68 16.06v9.83h8.94\"/></svg>"


//////////////////
// WEBPACK FOOTER
// ./~/graphcool-styles/icons/stroke/history.svg
// module id = 238
// module chunks = 0